import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

export type AlertType = 'error' | 'warning' | 'info' | 'success';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './alert.component.html'
})
export class AlertComponent {
  @Input() type: AlertType = 'error';
  @Input() message?: string;
  @Input() dismissible: boolean = false;

  @Output() dismiss = new EventEmitter<void>();

  onDismiss(): void {
    this.dismiss.emit();
  }
}
